import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { VideoCardFooterIcons } from "../assets/data/Datas";
import { useDispatch, useSelector } from "react-redux";
import {
    friendsFeeds,
    localFeeds,
    getHomePageVideo,
    setCurrentIndexfn,
    setPageNumber,
    followUser,
    getVideoShared,
    setClearHomepageVideos,
    getWithoutLoginVideos,
    reshareRemove,
    reshareVideo,
    getVideoById,
} from "../redux/ApiSlice/HomePageVideoSlice";
import PersonalizeModal from "../components/Modals/PersonalizeModal";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { matchPath, useLocation, useNavigate, useParams } from "react-router-dom";
import { BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import Footer from "../components/footer/Footer";
import { IoLocationSharp } from "react-icons/io5";
import { MdMyLocation, MdGroups } from "react-icons/md";
import { postLocation } from "../redux/ApiSlice/LocationSlice";
import toast, { Toaster } from "react-hot-toast";
import {
    AccountProfile,
    UserAccountFollow,
} from "../redux/ApiSlice/AccountProfileSlice";
import LocationDetectModal from "../components/Modals/locationDetectModal";
import { CiStreamOn } from "react-icons/ci";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDown, IoIosSearch } from "react-icons/io";
import { GiThreeFriends } from "react-icons/gi";
import { FaBasketShopping } from "react-icons/fa6";
import { IoNotifications, IoCloseCircle } from "react-icons/io5";
import VideoCarousel from "../components/home/VideoCarousel";
import { postReshare } from "../redux/ApiSlice/ResharedSlice";
import { userStatusChangeOld } from "../redux/ApiSlice/UserStatusSlice";
import { getUserPreferences } from "../utils/userPreferences";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from 'lucide-react';
import { useNotificationUnreadCount } from "../context/SocketContext";


export default function HomeMainPage() {
    // Detect Chrome on iOS
    const isChromeOniOS = (() => {
        if (typeof navigator === "undefined") return false;
        const ua = navigator.userAgent;
        return /CriOS/i.test(ua) && /iphone|ipad|ipod/i.test(ua);
    })();

    // Detect iPhone (Safari and Chrome)
    const isIPhone = (() => {
        if (typeof navigator === "undefined") return false;
        const ua = navigator.userAgent;
        return /iphone|ipod/i.test(ua);
    })();

    const params = useParams();
    const { id, videoId } = params;
    const auth = useSelector((state) => state.auth);
    const [userLogin, setUserLogin] = useState(null);
    const token = auth.accessToken;
    const location = useLocation();
    useEffect(() => {
        setUserLogin(token);
    }, [token]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const getAllPost = useSelector((state) => state.HomePageVideo);
    const { videoData, homePageVideos } = getAllPost;
    const { sessionLocation, permissionType } = useSelector((state) => state.LocationAddress);
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile } = ProfileDetails;

    const [videoDataList, setVideoDataList] = useState([]);
    const [newUser, setNewUser] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(getAllPost.currentIndex);
    const [direction, setDirection] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [openPersonalizeBottom, setOpenPersonalizeBottom] = useState(false);
    const [locationDetectorModal, setLocationDetectorModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [yourFeeds, setYourFeeds] = useState(false);
    const [localFeed, setLocalFeed] = useState(false);
    // const [yourFeeds, setYourFeeds] = useState(sessionStorage.getItem("friendsFeedVisited") === "true");
    // const [localFeed, setLocalFeed] = useState(sessionStorage.getItem("localFeedVisited") === "true");
    const [playbackSpeed, setPlaybackSpeed] = useState(1);
    const [showShopPopup, setShowShopPopup] = useState(false);
    const [showWelcome, setShowWelcome] = useState(false);
    const [isFollow, setIsFollow] = useState(false);
    const [resharedPostId, setResharedPostId] = useState(null);
    const [rehsaredMesaage, setResharedMessage] = useState(null);
    const [showPopupLogin, setShowPopupLogin] = useState(false);
    const [showEmptyLocalFeedPopup, setShowEmptyLocalFeedPopup] = useState(false);
    const [localFeedCountyName, setLocalFeedCountyName] = useState("");
    const [exitReasonHint, setExitReasonHint] = useState("swiped_away");
    const [showLocalLocation, setShowLocalLocation] = useState(false);
    const reshareTimeoutRef = useRef(null);
    const localLocationTimeoutRef = useRef(null);
    const [isLoadingSpecificVideo, setIsLoadingSpecificVideo] = useState(false);
    const hasLoadedSpecificVideo = useRef(false);
    const isPreloadingRef = useRef(false);
    const isScrollingRef = useRef(false);
    const wheelUnlockTimeoutRef = useRef(null);
    const videoReadyRef = useRef(true);
    const videoReadyTimeoutRef = useRef(null);
    const isFirstMountFeedRef = useRef(true);

    // User preferences for video playback (backed by localStorage "userVideoPreferences")
    const [videoPreferences, setVideoPreferences] = useState(() => getUserPreferences());

    useEffect(() => {
        const handlePreferencesChanged = (event) => {
            setVideoPreferences(event.detail || getUserPreferences());
        };

        window.addEventListener("preferencesChanged", handlePreferencesChanged);
        return () => {
            window.removeEventListener("preferencesChanged", handlePreferencesChanged);
        };
    }, []);

    useEffect(() => {
        if (reshareTimeoutRef.current) {
            clearTimeout(reshareTimeoutRef.current);
            reshareTimeoutRef.current = null;
        }

        if (!rehsaredMesaage) {
            return undefined;
        }

        reshareTimeoutRef.current = setTimeout(() => {
            setResharedPostId(null);
            setResharedMessage(null);
            reshareTimeoutRef.current = null;
        }, 5000);

        return () => {
            if (reshareTimeoutRef.current) {
                clearTimeout(reshareTimeoutRef.current);
                reshareTimeoutRef.current = null;
            }
        };
    }, [rehsaredMesaage]);

    const openPersonalizeDrawer = () => setOpenPersonalizeBottom(true);
    const closePersonalizeDrawer = () => setOpenPersonalizeBottom(false);

    const notificationUnreadCountWs = useNotificationUnreadCount();
    const notificationUnreadCount = notificationUnreadCountWs?.data || { unread_count: 0 };



    const handleInteraction = () => {
        if (!token) {
            // assume login check from token or session
            setShowPopupLogin(true);
        }
    };

    const handleToggleLocalLocation = () => {
        if (!localFeed) return;
        setShowLocalLocation((prev) => !prev);
    };

    const HeaderIcons = useMemo(() => [
        {
            icon: (
                <MdOutlineMapsHomeWork
                    color={localFeed ? "#3b82f6" : "white"}
                    className="h-[20px] w-[20px]"
                />
            ),
            placeholder: "City Feed",
            path: "localfeed",
        },
        {
            icon: (
                <GiThreeFriends
                    color={yourFeeds ? "#3b82f6" : "white"}
                    className="h-[20px] w-[20px]"
                />
            ),
            placeholder: "Friends",
            path: "yourfriends",
        },
        {
            icon: <IoIosSearch color="white" className="h-[20px] w-[20px]" />,
            placeholder: "Search",
            path: "search",
        },
        // {
        //     icon: <MdGroups color="white" className="h-[20px] w-[20px]" />,
        //     placeholder: "Groups",
        //     path: "groups",
        // },
        {
            icon: (
                <div className="relative flex items-center justify-center">
                    <IoNotifications color="white" className="h-[20px] w-[20px]" />
                    {notificationUnreadCount?.unread_count > 0 && (
                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[8px] font-bold rounded-full h-4 w-4 flex items-center justify-center min-w-[16px]">
                            {notificationUnreadCount.unread_count}
                        </span>
                    )}
                </div>
            ),
            placeholder: "Notifications",
            path: "notification",
        },
        // {
        //     icon: <CgScrollH color="white" className="h-[20px] w-[20px]" />,
        //     placeholder: "Personalize",
        //     path: "personalize",
        // },
    ], [localFeed, yourFeeds, notificationUnreadCount?.unread_count]);

    const handleHeaderNavigate = (value) => {
        const replaceValue = value.replaceAll(" ", "");
        if (!userLogin) {
            handleInteraction();
        } else {
            switch (replaceValue) {
                case "localfeed":
                    return localFeed ? null : handleLocalFeed();
                case "yourfeed":
                case "yourfriends":
                    return yourFeeds ? null : handleFriendsFeed();
                case "groups":
                    return navigate(`/group/list-view`);
                default:
                    navigate(`/${replaceValue}`);
                    break;
            }
        }
    };


    const handleReshared = async (postId) => {
        if (!userLogin) {
            return handleInteraction();
        }
        try {
            const response = await dispatch(postReshare({ postId }));

            if (response?.payload?.message === "Repost undone successfully!") {
                const updatedArray = videoDataList?.map((item) => {
                    return {
                        ...item,
                        userreshared:
                            item.id === postId ? !item?.userreshared : item?.userreshared,
                    };
                });
                setVideoDataList(updatedArray);

                setResharedPostId(postId);
                setResharedMessage("Repost Removed");
                dispatch(reshareRemove(postId));
            } else {
                const updatedArray = videoDataList?.map((item) => {
                    return {
                        ...item,
                        userreshared:
                            item.id === postId ? !item?.userreshared : item?.userreshared,
                    };
                });

                setVideoDataList(updatedArray);

                setResharedPostId(postId);
                setResharedMessage("Reposted");
                dispatch(reshareVideo(postId));
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleReadUserStatus = useCallback(async () => {
        try {
            const response = await dispatch(userStatusChangeOld());
            setShowWelcome(response?.payload?.new_user);
        } catch (error) {
            console.error(error);
        }
    }, [dispatch]);

    const handleFollowFun = async (id) => {
        if (!userLogin) {
            return handleInteraction();
        }
        try {
            const response = await dispatch(UserAccountFollow(id));
            const updatedArray = videoDataList?.map((item) => {
                return {
                    ...item,
                    userfollowing:
                        item.created_by.id === id
                            ? !item?.userfollowing
                            : item?.userfollowing,
                };
            });
            setVideoDataList(updatedArray);
            dispatch(followUser({ id }));

            setIsFollow(true);

            setTimeout(() => {
                setIsFollow(false);
            }, 2000);

            toast.success(response?.payload?.message);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        setNewUser(videoData?.new_user);
    }, [videoData]);

    useEffect(() => {
        if (newUser) {
            setShowWelcome(newUser);
            setTimeout(() => {
                handleReadUserStatus();
            }, 4000);
        }
    }, [newUser, handleReadUserStatus]);


    // useEffect(() => {
    //     const currentPostId = videoDataList[currentIndex]?.id;
    //     if (!matchPath("/v/:videoId", pathname) && currentPostId) {
    //         dispatch(getVideoShared(currentPostId));
    //     }
    // }, [dispatch, pathname, currentIndex, videoDataList]);

    useEffect(() => {
        if (!showLocalLocation) {
            if (localLocationTimeoutRef.current) {
                clearTimeout(localLocationTimeoutRef.current);
                localLocationTimeoutRef.current = null;
            }
            return;
        }

        localLocationTimeoutRef.current = setTimeout(() => {
            setShowLocalLocation(false);
            localLocationTimeoutRef.current = null;
        }, 5000);

        return () => {
            if (localLocationTimeoutRef.current) {
                clearTimeout(localLocationTimeoutRef.current);
                localLocationTimeoutRef.current = null;
            }
        };
    }, [showLocalLocation]);

    useEffect(() => {
        if (localFeed) {
            setShowLocalLocation(true);
        } else {
            setShowLocalLocation(false);
        }
    }, [localFeed]);
    // Detect screen size
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch initial data on mount — split into two effects so homePageVideos
    // changes never re-trigger the /v/:videoId path (which caused an infinite loop).

    // Effect 1: /v/:videoId path — only re-runs if the videoId param changes
    useEffect(() => {
        if (!videoId || hasLoadedSpecificVideo.current) return;
        hasLoadedSpecificVideo.current = true;

        // User returning from another page — videos already in Redux, no API call needed
        if (homePageVideos.length > 0) {
            const videoIndex = homePageVideos.findIndex(v => String(v.id) === String(videoId));
            setCurrentIndex(videoIndex !== -1 ? videoIndex : getAllPost.currentIndex);
            setVideoDataList(homePageVideos);
            setPageCount(getAllPost.pageNumber);
            return;
        } else if (!userLogin && !token) {
            getDataForPaginated(1);
        }
        // Fresh load via direct video link — fetch from API
        dispatch(setClearHomepageVideos());
        fetchSpecificVideo(videoId);
    }, [videoId]); // eslint-disable-line react-hooks/exhaustive-deps

    // Effect 2: Home path — runs once on mount, reads Redux snapshot
    useEffect(() => {
        if (videoId) return; // handled by effect 1
        if (homePageVideos.length > 0) {
            setCurrentIndex(getAllPost.currentIndex);
            setVideoDataList(homePageVideos);
            setPageCount(getAllPost.pageNumber);
        } else {
            getDataForPaginated(1);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Fetch specific video by ID
    const fetchSpecificVideo = useCallback(async (videoId) => {
        setIsLoadingSpecificVideo(true);
        if (!userLogin && !token) {
            return navigate('/');
        }

        try {
            const response = await dispatch(getVideoById(videoId));
            const specificVideo = await response.payload;

            let apiResponse;
            if (token === null) {
                apiResponse = await dispatch(getWithoutLoginVideos(1));
            } else {
                // const yourfeedvideosResponse = await dispatch(friendsFeeds(1));
                apiResponse = await dispatch(getHomePageVideo(1));
            }

            const feedVideos = apiResponse?.payload?.post || [];
            // Check if specific video is already in the feed
            const videoIndex = feedVideos.findIndex(v => v.id === parseInt(videoId));
            if (videoIndex !== -1) {
                setVideoDataList(feedVideos);
                setCurrentIndex(videoIndex);
            } else {
                // Video not in feed, prepend it
                // Double-check to prevent duplicates
                const filteredFeedVideos = feedVideos.filter(v => v.id !== parseInt(videoId));
                const updatedList = [specificVideo, ...filteredFeedVideos];
                setVideoDataList(updatedList);
                setCurrentIndex(0);
            }
            // Update URL to reflect the currently displayed video
            setTimeout(() => {
                const displayedVideo = videoIndex !== -1 ? feedVideos[videoIndex] : specificVideo;
                if (displayedVideo?.id) {
                    window.history.replaceState(null, '', `/v/${displayedVideo.id}`);
                }
            }, 100);

            return specificVideo;
        } catch (error) {
            console.error("Error fetching specific video:", error);
            toast.error("Video not found. Loading regular feed...");
            // Fallback to regular feed
            await getDataForPaginated(1);
            return null;
        } finally {
            setIsLoadingSpecificVideo(false);
            hasLoadedSpecificVideo.current = true;
        }
    }, [dispatch, userLogin]);

    // Fetch data for paginated pages
    const getDataForPaginated = useCallback(
        async (count) => {
            setLoading(true);
            try {
                let apiResponse;
                if (token === null) {
                    // User is NOT logged in - call getWithoutLoginVideos
                    apiResponse = await dispatch(getWithoutLoginVideos(count));
                } else {
                    // User IS logged in - call getHomePageVideo
                    apiResponse = await dispatch(getHomePageVideo(count));
                }

                if (Array.isArray(apiResponse?.payload?.post)) {
                    setVideoDataList((prev) => [
                        ...prev,
                        ...apiResponse.payload.post.filter(newPost => !prev.some(existingPost => existingPost.id === newPost.id))
                    ]);

                    return apiResponse.payload.post;
                }

                return [];
            } catch (error) {
                console.error("Error fetching data:", error);
                return [];
            } finally {
                setLoading(false);
            }
        }, [dispatch, token]);

    const handleNext = async () => {
        if (showLocalLocation) {
            setShowLocalLocation(false);
        }
        setExitReasonHint("swiped_up");

        // Preload next page when user is 3 videos before the end (video 3 of 5),
        // giving 2 full videos of scroll time for the API response to arrive.
        const preloadThreshold = 3;
        const shouldPreload = currentIndex === videoDataList.length - preloadThreshold &&
            !isPreloadingRef.current &&
            Boolean(videoData?.next);

        if (shouldPreload) {
            isPreloadingRef.current = true;
            try {
                const nextPage = pageCount + 1;
                if (yourFeeds) {
                    const res = await dispatch(friendsFeeds(nextPage));
                    if (res.payload?.results?.post && res.payload.results.post.length > 0) {
                        setVideoDataList((prev) => [...prev, ...res.payload.results.post]);
                        setPageCount(nextPage);
                        dispatch(setPageNumber(nextPage));
                    }
                } else if (localFeed) {
                    const res = await dispatch(localFeeds(nextPage));
                    if (res.payload?.posts && res.payload.posts.length > 0) {
                        setVideoDataList((prev) => [...prev, ...res.payload.posts]);
                        setPageCount(nextPage);
                        dispatch(setPageNumber(nextPage));
                    }
                } else {
                    await getDataForPaginated(nextPage);
                    setPageCount(nextPage);
                    dispatch(setPageNumber(nextPage));
                }
            } catch (error) {
                console.error("Error preloading videos:", error);
            } finally {
                isPreloadingRef.current = false;
            }
        }

        // If at the last video in the current list
        if (currentIndex === videoDataList.length - 1) {
            // Check if there is a next page
            if (Boolean(videoData?.next)) {
                // If preload already happened, just move to next video
                if (!isPreloadingRef.current) {
                    const nextPage = pageCount + 1;
                    if (yourFeeds) {
                        const res = await dispatch(friendsFeeds(nextPage));
                        setVideoDataList((prev) => [...prev, ...(res.payload?.results?.post || [])]);
                        setPageCount(nextPage);
                        dispatch(setPageNumber(nextPage));
                        setCurrentIndex((prevIndex) => prevIndex + 1);
                    } else if (localFeed) {
                        const res = await dispatch(localFeeds(nextPage));
                        if (res.payload?.posts && res.payload.posts.length > 0) {
                            setVideoDataList((prev) => [...prev, ...res.payload.posts]);
                            setPageCount(nextPage);
                            dispatch(setPageNumber(nextPage));
                            setCurrentIndex((prevIndex) => prevIndex + 1);
                        }
                    } else {
                        await getDataForPaginated(nextPage);
                        setPageCount(nextPage);
                        dispatch(setPageNumber(nextPage));
                        setCurrentIndex((prevIndex) => prevIndex + 1);
                    }
                } else {
                    // Data already preloaded, just move index
                    setCurrentIndex((prevIndex) => prevIndex + 1);
                }
            } else {
                !userLogin ? handleInteraction() : null;
            }
            // If no next page, do nothing (or you could loop to start, etc.)
        } else {
            // Move to the next video in the list
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
        setDirection(1);
    };
    // Handle previous video
    const handlePrev = () => {
        if (currentIndex === 0) return;
        if (showLocalLocation) {
            setShowLocalLocation(false);
        }
        setExitReasonHint("swiped_down");
        setCurrentIndex((prevIndex) => prevIndex - 1);
        setDirection(-1);
    };

    const onVideoReady = useCallback(() => {
        if (videoReadyTimeoutRef.current) {
            clearTimeout(videoReadyTimeoutRef.current);
            videoReadyTimeoutRef.current = null;
        }
        videoReadyRef.current = true;
    }, []);

    const handleRefresh = () => {
        // sessionStorage.setItem("friendsFeedVisited", false);
        // sessionStorage.setItem("localFeedVisited", false);
        setPageCount(1);
        dispatch(setPageNumber(1));
        dispatch(setClearHomepageVideos());
        setVideoDataList([]);
        getDataForPaginated(1);
        setCurrentIndex(0);
        setYourFeeds(false);
        setLocalFeed(false);
        hasLoadedSpecificVideo.current = false;
        // Reset URL to home
        window.history.replaceState(null, '', '/');
    };

    // Handle friends feed
    const fetchFriendsFeeds = async () => {
        setLoading(true);
        try {
            const response = await dispatch(friendsFeeds(pageCount));
            if (Array.isArray(response.payload.results.post)) {
                setVideoDataList(response.payload.results.post || []);
                setCurrentIndex(0);
                setPageCount(1);
            }
        } catch (error) {
            console.error("Error fetching friends feeds:", error);
        } finally {
            setLoading(false);
        }
    };

    // Handle local feed
    const fetchLocalFeeds = async () => {
        setLoading(true);
        try {
            const response = await dispatch(localFeeds(pageCount));

            // Check if the request was rejected (400 error - location not set)
            if (
                response.meta?.requestStatus === "rejected" ||
                response.payload?.detail
            ) {
                if (
                    response.payload?.detail ===
                    "Please update your location (county) first."
                ) {
                    setLocalFeed(false);
                    setLoading(false);
                    navigate("/neighborhood/location");
                    return;
                }
            }

            // Check if posts array is empty
            if (response.payload?.posts && response.payload.posts.length === 0) {
                setLocalFeedCountyName(response.payload?.county_name || "");
                setShowEmptyLocalFeedPopup(true);
                setLocalFeed(false);
                setLoading(false);
                return;
            }

            if (Array.isArray(response.payload?.posts)) {
                setVideoDataList(response.payload.posts || []);
                setCurrentIndex(0);
                setPageCount(1);
            }
        } catch (error) {
            console.error("Error fetching local feeds:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isFirstMountFeedRef.current) {
            isFirstMountFeedRef.current = false;
            return;
        }
        if (yourFeeds) {
            setPageCount(1);
            setVideoDataList([]);
            fetchFriendsFeeds();
        } else if (localFeed) {
            setPageCount(1);
            setVideoDataList([]);
            fetchLocalFeeds();
        } else {
            setVideoDataList(homePageVideos);
            setCurrentIndex(getAllPost.currentIndex);
            setPageCount(getAllPost.pageNumber);
        }
    }, [yourFeeds, localFeed]);
    const handleFriendsFeed = () => {
        setVideoDataList([]);
        setCurrentIndex(0);
        setPageCount(1);
        setLocalFeed(false);
        setYourFeeds(true);
        // sessionStorage.setItem("friendsFeedVisited", true);
        // sessionStorage.setItem("localFeedVisited", false);
    };

    const handleLocalFeed = () => {
        setVideoDataList([]);
        setCurrentIndex(0);
        setPageCount(1);
        setYourFeeds(false);
        setLocalFeed(true);
        // sessionStorage.setItem("friendsFeedVisited", false);
        // sessionStorage.setItem("localFeedVisited", true);
    };

    const handleNavigate = (value) => {
        const replaceValue = value.replaceAll(" ", "");
        if (!userLogin) {
            handleInteraction();
        } else {
            switch (replaceValue) {
                case "Messages":
                    return navigate(`/message`);
                case "Createvideo":
                    return navigate(`/create-videos`);
                case "Home":
                    return handleRefresh();
                case "Neighborhood":
                    return navigate(`/neighborhood`);
                case "Account":
                    return navigate(`/account`);
                case "YourFriends":
                    return handleFriendsFeed();
                case "YourCC":
                    return navigate(`/commingsoon`);
                case "Helmet1":
                    return navigate(`/commingsoon`);
                case "Groups":
                    return navigate(`/othergroup/list/`);
                default:
                    // navigate(`/${replaceValue}`);
                    break;
            }
        }
    };

    const uploadLoacation = async (lat, lng) => {
        try {
            const responce = await dispatch(
                postLocation({ latitude: lat, longitude: lng }),
            );
            if (responce?.payload?.message) {
                toast.success(responce?.payload?.message);
                dispatch(AccountProfile());
                setIsLoading(false);
                setLocationDetectorModal(false);
                // Trigger local feed fetch after location is updated
                setLocalFeed(true);
            }
        } catch (error) {
            toast.error("Error fetching address details");
            setIsLoading(false);
        }
    };

    const handleDetectLocation = () => {
        if (navigator.geolocation) {
            setIsLoading(true);
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    uploadLoacation(lat, lng);
                },
                (error) => {
                    console.error("Error detecting location: ", error);
                    setIsLoading(false);
                },
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };

    // Keep URL in sync with current video
    useEffect(() => {
        if (videoDataList.length > 0 && videoDataList[currentIndex]?.id) {
            const currentVideoId = videoDataList[currentIndex].id;
            const currentPath = window.location.pathname;
            const expectedPath = `/v/${currentVideoId}`;

            // Only update if URL doesn't match current video and we're not on home without videoId param
            if (currentPath !== expectedPath) {
                window.history.replaceState(null, '', expectedPath);
            } else if (videoId && currentPath !== expectedPath) {
                // If we came via videoId route, always keep URL updated
                window.history.replaceState(null, '', expectedPath);
            }
        }
    }, [currentIndex, videoDataList, videoId]);

    // Handle keyboard and mouse wheel navigation
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!videoReadyRef.current) return;
            if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                handlePrev();
            } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                if (loading) return;
                handleNext();
            }
        };

        const handleWheel = (event) => {
            // Don't intercept wheel events inside scrollable containers (e.g. comments drawer)
            let el = event.target;
            while (el && el !== document.documentElement) {
                const overflowY = window.getComputedStyle(el).overflowY;
                if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
                    return;
                }
                el = el.parentElement;
            }

            // Prevent default scrolling behavior
            event.preventDefault();

            // Block scroll while current video is still buffering
            if (!videoReadyRef.current) return;

            // Already mid-gesture (e.g. trackpad inertia still firing wheel events):
            // extend the lock instead of re-triggering, so it only releases once the
            // gesture actually stops rather than on a fixed clock from the first event.
            if (isScrollingRef.current) {
                clearTimeout(wheelUnlockTimeoutRef.current);
                wheelUnlockTimeoutRef.current = setTimeout(() => {
                    isScrollingRef.current = false;
                }, 200);
                return;
            }

            // deltaY > 0 means scrolling down, < 0 means scrolling up
            if (event.deltaY > 0) {
                if (loading) return;
                isScrollingRef.current = true;
                videoReadyRef.current = false;
                videoReadyTimeoutRef.current = setTimeout(() => {
                    videoReadyRef.current = true;
                }, 2000); // safety unlock if onVideoReady never fires
                handleNext();
                wheelUnlockTimeoutRef.current = setTimeout(() => { isScrollingRef.current = false; }, 500);
            } else if (event.deltaY < 0) {
                isScrollingRef.current = true;
                videoReadyRef.current = false;
                videoReadyTimeoutRef.current = setTimeout(() => {
                    videoReadyRef.current = true;
                }, 2000);
                handlePrev();
                wheelUnlockTimeoutRef.current = setTimeout(() => { isScrollingRef.current = false; }, 500);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("wheel", handleWheel, { passive: false });

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("wheel", handleWheel);
            clearTimeout(wheelUnlockTimeoutRef.current);
        };
    }, [currentIndex, videoDataList, loading]);

    useEffect(() => {
        dispatch(setCurrentIndexfn(currentIndex));
    }, [dispatch, currentIndex]);



    return (
        <>
            <Toaster position="top-right" />
            {/* Fixed header - completely separate from video container */}
            <div className="w-full md:w-[75%] lg:w-[60%] xl:w-[55%] pt-4 md:absolute fixed top-0 z-50 px-3 bg-gradient-to-b from-black bg-opacity-30 pointer-events-auto md:rounded-t-[20px]">
                <div className="flex justify-between items-center">
                    {HeaderIcons.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center pb-[2px] group"
                            onClick={() => {
                                if (item.path === "shop") {
                                    setShowShopPopup(!showShopPopup);
                                } else if (item.path === "personalize") {
                                    openPersonalizeDrawer();
                                } else {
                                    handleHeaderNavigate(`${item.path}`);
                                }
                            }}
                        >
                            <div className={`${(yourFeeds && item.path == "yourfriends") || (localFeed && item.path == "localfeed") ? "text-blue-500" : "text-white"} cursor-pointer opacity-100 group-hover:scale-110 transition-transform duration-300 ease-in-out`}>
                                {item.icon}
                            </div>
                            <p className={`${(yourFeeds && item.path == "yourfriends") || (localFeed && item.path == "localfeed") ? "text-blue-500" : "text-white"} cursor-pointer font-semibold text-[7px] mt-[1px] group-hover:scale-110 transition-transform duration-300 ease-in-out`}>
                                {item.placeholder}
                            </p>
                        </div>
                    ))}
                </div>
                {localFeed && (
                    <div className="mt-2 flex items-center gap-2">
                        <motion.button
                            layout
                            type="button"
                            aria-expanded={showLocalLocation}
                            aria-label="Toggle local location"
                            onClick={handleToggleLocalLocation}
                            transition={{ type: "spring", stiffness: 500, damping: 30 }}
                            className="flex items-center gap-1 rounded-full bg-black/40 px-1 py-1 text-white text-[9px] font-semibold overflow-hidden"
                        >
                            <IoLocationSharp className="h-[12px] w-[12px] text-[#3b82f6]" />
                            {showLocalLocation && (
                                <span className="inline-block whitespace-nowrap">
                                    {User_profile?.session_location?.city || User_profile?.session_location?.display || "Location not enabled"}
                                </span>
                            )}
                            <motion.span
                                animate={{ rotate: showLocalLocation ? 180 : 0 }}
                                transition={{ duration: 0.2 }}
                                className="flex items-center"
                            >
                                <IoIosArrowForward className="text-[12px] text-white" />
                            </motion.span>
                        </motion.button>
                    </div>
                )}
            </div>

            <div className="hidden md:flex md:w-[10%] mr-4" />
            <div className="h-full w-full md:w-[75%] lg:w-[60%] xl:w-[55%] bg-black border-black md:border-[2px] relative md:rounded-[20px] overflow-hidden">
                <div className="h-[88%]">
                    <VideoCarousel
                        // loading={loading}
                        // fetchData={fetchData}
                        videos={videoDataList}
                        itsNotHome={false}
                        isMobile={isMobile}
                        isFollow={isFollow}
                        direction={direction}
                        yourFeeds={yourFeeds}
                        newUser={showWelcome}
                        handleNext={handleNext}
                        handlePrev={handlePrev}
                        totalVideos={videoDataList?.length}
                        currentIndex={currentIndex}
                        setDirection={setDirection}
                        handleRefresh={handleRefresh}
                        playbackSpeed={playbackSpeed}
                        handleReshared={handleReshared}
                        resharedPostId={resharedPostId}
                        setCurrentIndex={setCurrentIndex}
                        rehsaredMesaage={rehsaredMesaage}
                        handleFollowFun={handleFollowFun}
                        setPlaybackSpeed={setPlaybackSpeed}
                        setResharedPostId={setResharedPostId}
                        handleReadUserStatus={handleReadUserStatus}
                        userLogin={userLogin}
                        exitReasonHint={exitReasonHint}
                        handleInteraction={handleInteraction}
                        enableAutoplay={videoPreferences.enableAutoplay}
                        muteVideosByDefault={videoPreferences.muteVideosByDefault}
                        videoId={videoId}
                        onVideoReady={onVideoReady}
                    // comments_enabled={posts[currentIndex]?.comments_enabled}
                    />
                </div>
                <div
                    style={{
                        paddingBottom: isChromeOniOS
                            ? "calc(env(safe-area-inset-bottom, 0px) + 0px)"
                            : "env(safe-area-inset-bottom)",
                    }}
                    className="h-full w-full bg-[#333333] dark:bg-[#333333]"
                >
                    <Footer
                        isFixedDark={true}
                        yourFeeds={yourFeeds}
                        deactiveIcon={yourFeeds || localFeed ? true : false}
                        handleRefresh={handleRefresh}
                        handleNavigate={handleNavigate}
                        VideoCardHeaderIcons={VideoCardFooterIcons}
                        setLocationDetectorModal={setLocationDetectorModal}
                        userLogin={userLogin}
                        handleInteraction={handleInteraction}
                    />
                </div>

                {/* Empty Local City Feed Popup */}
                {showEmptyLocalFeedPopup && (
                    <div className="absolute inset-0 bg-black bg-opacity-60 dark:bg-black dark:bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-sm animate-fadeIn p-0 rounded-[20px]">
                        <div className="relative bg-gradient-to-br from-white via-gray-50 to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-700 p-4 rounded-2xl shadow-2xl dark:shadow-gray-900/50 text-center max-w-md w-full mx-4 transform animate-slideUp border border-gray-200 dark:border-gray-600">
                            {/* Close button */}
                            <button
                                onClick={() => setShowEmptyLocalFeedPopup(false)}
                                className="absolute top-4 right-4 text-gray-900 dark:text-gray-300 hover:text-gray-600 dark:hover:text-gray-100 transition-colors duration-200 p-1"
                            >
                                <IoCloseCircle className="w-6 h-6" />
                            </button>

                            {/* Icon */}
                            <div className="mb-6 flex justify-center">
                                <div className="w-16 h-16 bg-gradient-to-r from-[#BDE6FF] to-[#b3e0fc] rounded-full flex items-center justify-center shadow-lg">
                                    <MdOutlineMapsHomeWork className="w-8 h-8 text-black/85" />
                                </div>
                            </div>

                            {/* Title and Description */}
                            <h2 className="text-[20px] font-bold mb-3 text-black dark:text-white">
                                No Local Posts Found
                            </h2>

                            <p className="text-black dark:text-white mb-6 text-[12px] leading-relaxed">
                                {localFeedCountyName
                                    ? `There are no posts available in ${localFeedCountyName} at the moment. Be the first to share something with your local community!`
                                    : "There are no posts available in your area at the moment. Be the first to share something with your local community!"}
                            </p>

                            {/* Action Button */}
                            <button
                                onClick={() => setShowEmptyLocalFeedPopup(false)}
                                className="w-full bg-gradient-to-r from-[#BDE6FF] to-[#b3e0fc] text-black/85 px-6 py-3 rounded-xl font-semibold shadow-lg hover:from-[#a9cee4] hover:to-[#BDE6FF] transform hover:scale-105 transition-all duration-200 hover:shadow-xl"
                            >
                                Got It
                            </button>
                        </div>
                    </div>
                )}

                {/* Location Detector Modal for Local City Feed */}
                {locationDetectorModal && (
                    <div className="absolute inset-0 bg-black bg-opacity-60 dark:bg-black dark:bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-sm animate-fadeIn p-0 rounded-[20px]">
                        <div
                            className="bg-white dark:bg-gray-800 p-4 px-4 w-[90%] md:w-[80%] rounded-lg shadow-lg"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex justify-center items-center mb-2">
                                <p className="text-[20px] font-bold text-black dark:text-white">
                                    Allow Location
                                </p>
                            </div>

                            <div className="mb-3">
                                <p className="text-[12px] text-gray-700 dark:text-gray-300">
                                    To view local posts in your area, please allow location
                                    permissions so we can detect your county.
                                </p>

                                <div className="flex justify-center mt-4 items-center">
                                    <button
                                        type="button"
                                        onClick={handleDetectLocation}
                                        className="text-[14px] bg-[#fff] w-full flex justify-center items-center gap-4 hover:bg-black hover:text-white text-black px-4 py-2 rounded-md font-bold border border-black"
                                    >
                                        {isLoading ? "Finding Location..." : "Detect Location"}
                                        <MdMyLocation className="text-[13px] text-blue-600" />
                                    </button>
                                </div>
                                <button
                                    onClick={() => setLocationDetectorModal(false)}
                                    className="w-full text-[14px] rounded-md mt-4 px-4 py-2 bg-red-500 hover:bg-opacity-90 text-black border border-black font-semibold"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* <PersonalizeModal
                    openBottom={openPersonalizeBottom}
                    closeDrawerBottom={closePersonalizeDrawer}
                /> */}
            </div>

            <div className="hidden md:flex h-full items-center md:w-[10%] ml-4">
                <div className="flex flex-col gap-5">
                    <button
                        onClick={loading ? null : handlePrev}
                        disabled={currentIndex === 0 || videoDataList?.length === 0}
                        className="disabled:opacity-50 disabled:cursor-not-allowed h-12 w-12 rounded-full bg-[#A8D7F2] text-[#365975] hover:bg-[#94CAE9] flex items-center justify-center"
                    >
                        <BiSolidUpArrow className="text-[16px]" />
                    </button>
                    <button
                        disabled={loading || videoDataList?.length === 0}
                        className="disabled:opacity-50 disabled:cursor-not-allowed h-12 w-12 rounded-full bg-[#A8D7F2] text-[#365975] hover:bg-[#94CAE9] flex items-center justify-center"
                        onClick={handleNext}
                    >
                        <BiSolidDownArrow className="text-[16px]" />
                    </button>
                </div>
            </div>

            {showShopPopup && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-[20%] h-[28vh] flex flex-col items-center justify-center">
                        <p className="text-[18px] font-semibold text-black whitespace-nowrap">
                            Chaa Chingg's Shop
                        </p>
                        <p className="text-[14px] font-semibold text-gray-800 text-center mt-2">
                            We are currently working on Chaa Chingg's Shop. We are planning on
                            launching our shop in November.
                        </p>
                        <button
                            onClick={() => setShowShopPopup(!showShopPopup)}
                            className="bg-white text-red-500 px-7 py-1 border border-gray-400 rounded-full mt-4 hover:bg-red-500 hover:text-white transition-colors duration-300"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* Enhanced Popup Modal with Dark/Light Mode Support */}
            {showPopupLogin && (
                <div className="fixed inset-0 bg-black bg-opacity-60 dark:bg-black dark:bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-sm animate-fadeIn p-4">
                    <div className="relative bg-gradient-to-br from-white via-gray-50 to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-700 p-8 rounded-2xl shadow-2xl dark:shadow-gray-900/50 text-center max-w-md w-full mx-4 transform animate-slideUp border border-gray-200 dark:border-gray-600">
                        {/* Close button */}
                        <button
                            onClick={() => setShowPopupLogin(false)}
                            className="absolute top-4 right-4 text-gray-900 dark:text-gray-300 hover:text-gray-600 dark:hover:text-gray-100 transition-colors duration-200 p-1"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>

                        {/* Icon */}
                        <div className="mb-6 flex justify-center">
                            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 dark:from-blue-400 dark:to-purple-500 rounded-full flex items-center justify-center shadow-lg">
                                <svg
                                    className="w-8 h-8 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* Title and Description */}
                        <h2 className="text-2xl font-bold mb-3 text-gray-800 dark:text-gray-100 bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 bg-clip-text text-transparent">
                            Welcome to Chaa Chingg!
                        </h2>
                        <p className="text-gray-600 dark:text-gray-300 mb-8 text-sm md:text-md   leading-relaxed">
                            Join our community to access exclusive content, connect with
                            friends, and share your amazing moments.
                        </p>

                        {/* Action Buttons */}
                        <div className="space-y-4">
                            <button
                                onClick={() => navigate("/login")}
                                className="w-full bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:from-blue-600 hover:to-blue-700 dark:hover:from-blue-700 dark:hover:to-blue-800 transform hover:scale-105 transition-all duration-200 hover:shadow-xl dark:shadow-blue-900/50"
                            >
                                Login
                            </button>
                            <button
                                onClick={() => navigate("/create-account-with")}
                                className="w-full bg-gradient-to-r border-black border from-emerald-500 to-emerald-600 dark:from-emerald-600 dark:to-emerald-700 text-black dark:text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:from-emerald-600 hover:to-emerald-700 dark:hover:from-emerald-700 dark:hover:to-emerald-800 transform hover:scale-105 transition-all duration-200 hover:shadow-xl dark:shadow-emerald-900/50"
                            >
                                Create New Account
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
